import styled from 'styled-components/macro'

export const RowInfo = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 15px;
`
